import { useState, useCallback } from 'react';

export const useMerge = (files: FileList | null, setMergeStatus: (status: string) => void) => {
    const [shouldMerge, setShouldMerge] = useState(false);
    const [mergedText, setMergedText] = useState<string | null>(null);
    const [mergeSuccessMessage, setMergeSuccessMessage] = useState('');

    const handleMergeClick = useCallback(() => {
        if (files) {
            setMergeStatus('processing');
            setShouldMerge(true);
        } else {
            setMergeStatus('idle');
        }
    }, [files, setMergeStatus]);

    return {
        shouldMerge,
        setShouldMerge,
        mergedText,
        mergeSuccessMessage,
        handleMergeClick,
        setMergedText,
        setMergeSuccessMessage
    };
};
